import { FC } from "react";
import ErrormiddlewareTable from "./proto/Errormiddleware";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import { useNavigate } from "react-router-dom";

import { TableInputProps } from "../Table";
import LoadingMiddlewareAnimInstance from "./LoadingMiddlewareAnimInstance";
import { useSelector } from "react-redux";

const TokenMiddlewareTable: FC<TableInputProps> = (props) => {
  const navigate = useNavigate();
  const tableErrorCode = useSelector(
    (state: any) => state.rootReducer.order?.errorCode
  );

  if (props.tableStateLogout) {
    navigate(0);

    return null;
  } else if (props.tableStateError) {
    return <ErrormiddlewareTable {...props} errorCode={tableErrorCode} />;
  } else {
    return <LoadingMiddlewareAnimInstance {...props} />;
  }
};

export default TokenMiddlewareTable;
